/*
 * df-entrega.js — «Recíbelo el mar 29 o el mié 30» fuera de la ficha.
 *
 * Pinta la fecha de entrega en todo lo que lleve [data-df-entrega]: la caja de
 * las colecciones y de las landings (snippets/df-entrega.liquid) y el mensaje
 * de la barra roja que diga [fechas] (df-ship-bar).
 *
 * La regla es la MISMA que la de la ficha (df-pdp-main.js), la cesta, el
 * carrito y el hero de la portada, y lee los mismos ajustes del tema
 * (Plazos de entrega):
 *   · el pedido sale hoy si hoy es laborable y aún no ha pasado el corte;
 *     si no, el primer laborable siguiente;
 *   · llega entre `min` y `max` laborables después de salir.
 * Hay que cambiarla en todos los sitios a la vez: dos cálculos distintos son
 * dos fechas distintas en dos clics, y el día que se nota es el de un festivo.
 *
 * Cuenta con la hora del dispositivo, igual que la ficha, para que las dos
 * digan siempre lo mismo.
 *
 * Medido el 27-09 con los pedidos a península desde el 14-09: de los hechos
 * antes de las 14:00 en laborable, el 85 % sale ese día y el 92 % se entrega
 * en 1-2 laborables. CTT no reparte en sábado (2 de 471 entregas), y por eso
 * el sábado no cuenta.
 *
 * Plantillas: cualquier nodo con data-df-entrega-tpl. [fechas], [dia],
 * [ahora] y [tiempo] los sustituye esto; [ahora] y [tiempo] salen en
 * seminegrita. data-df-entrega-tpl-urgente se usa en su lugar mientras el
 * pedido todavía puede salir hoy, que es lo único que el cliente puede perder.
 */
(function () {
  'use strict';
  if (window.DFEntrega) { window.DFEntrega.pintarTodo(); return; }

  function config(el) {
    return {
      corte: Number(el.getAttribute('data-cutoff-hour')) || 14,
      min: Number(el.getAttribute('data-days-min')) || 1,
      max: Number(el.getAttribute('data-days-max')) || 2,
      union: el.getAttribute('data-eta-join') || ' o el ',
      festivos: (el.getAttribute('data-festivos') || '')
        .split(',').map(function (x) { return x.trim(); }).filter(Boolean)
    };
  }

  function dos(n) { return n < 10 ? '0' + n : '' + n; }

  function esLaborable(d, c) {
    var wd = d.getDay();
    if (wd === 0 || wd === 6) return false;
    var iso = d.getFullYear() + '-' + dos(d.getMonth() + 1) + '-' + dos(d.getDate());
    return c.festivos.indexOf(iso) === -1;
  }

  function sumarLaborables(d, n, c) {
    var x = new Date(d), k = 0;
    while (k < n) { x.setDate(x.getDate() + 1); if (esLaborable(x, c)) k++; }
    return x;
  }

  function diaSalida(ahora, c) {
    var x = new Date(ahora);
    if (esLaborable(x, c) && x.getHours() < c.corte) return x;
    do { x.setDate(x.getDate() + 1); } while (!esLaborable(x, c));
    return x;
  }

  // «mar», «mié»: el mismo formato corto que la ficha.
  function wd3(d) {
    return d.toLocaleString('es-ES', { weekday: 'short' }).replace('.', '');
  }

  function calcular(el, ahora) {
    var c = config(el);
    ahora = ahora || new Date();
    var salida = diaSalida(ahora, c);
    var fMin = sumarLaborables(salida, c.min, c);
    var fMax = sumarLaborables(salida, c.max, c);
    var fechas = wd3(fMin) + ' ' + fMin.getDate();
    if (fMin.toDateString() !== fMax.toDateString()) {
      fechas += c.union + wd3(fMax) + ' ' + fMax.getDate();
    }

    var manana = new Date(ahora); manana.setDate(manana.getDate() + 1);
    var dia;
    if (salida.toDateString() === ahora.toDateString()) dia = 'hoy';
    else if (salida.toDateString() === manana.toDateString()) dia = 'mañana';
    else dia = 'el ' + wd3(salida);

    /* Horas y minutos, sin segundos: esto vive junto a una rejilla de
       productos y un segundero en marcha se lleva la vista. Por debajo de la
       hora se dice en minutos, que «0h 40m» no se lee de un golpe. */
    var corte = new Date(salida); corte.setHours(c.corte, 0, 0, 0);
    var mins = Math.max(1, Math.ceil((corte - ahora) / 60000));
    var tiempo = mins < 60 ? mins + ' min' : Math.floor(mins / 60) + 'h ' + dos(mins % 60) + 'm';

    return { fechas: fechas, dia: dia, tiempo: tiempo, saleHoy: dia === 'hoy', salida: salida, desde: fMin, hasta: fMax };
  }

  function pintar(raiz, ahora) {
    var r = calcular(raiz, ahora);
    var nodos = [].slice.call(raiz.querySelectorAll('[data-df-entrega-tpl]'));
    if (raiz.hasAttribute('data-df-entrega-tpl')) nodos.unshift(raiz);
    nodos.forEach(function (n) {
      var tpl = n.getAttribute('data-df-entrega-tpl') || '';
      var urgente = n.getAttribute('data-df-entrega-tpl-urgente');
      if (r.saleHoy && urgente) tpl = urgente;
      var linea = tpl.replace('[fechas]', r.fechas).replace('[dia]', r.dia);
      // Se reescribe solo si cambia: con la clave se evita rehacer los nodos
      // cada medio minuto para escribir lo mismo.
      var clave = linea.replace('[tiempo]', r.tiempo);
      if (n.getAttribute('data-df-entrega-linea') === clave) return;
      n.setAttribute('data-df-entrega-linea', clave);
      // Con nodos y no con innerHTML: el texto sale de un ajuste del tema.
      n.textContent = '';
      linea.split(/(\[ahora\]|\[tiempo\])/).forEach(function (t) {
        if (!t) return;
        if (t === '[ahora]' || t === '[tiempo]') {
          var s = document.createElement('span');
          s.className = 'df-entrega__fuerte' + (t === '[tiempo]' ? ' df-entrega__reloj' : '');
          s.textContent = t === '[ahora]' ? 'ahora' : r.tiempo;
          n.appendChild(s);
        } else {
          n.appendChild(document.createTextNode(t));
        }
      });
    });
    raiz.classList.add('is-lista');
  }

  function pintarTodo() {
    var ahora = new Date();
    var raices = document.querySelectorAll('[data-df-entrega]');
    for (var i = 0; i < raices.length; i++) pintar(raices[i], ahora);
  }

  window.DFEntrega = { calcular: calcular, pintar: pintar, pintarTodo: pintarTodo };

  // Va con `async`: puede llegar antes de que exista el resto de la página.
  pintarTodo();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintarTodo);
  }
  // Pasado el corte o la medianoche la fecha cambia sola.
  setInterval(pintarTodo, 30000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') pintarTodo();
  });
  document.addEventListener('shopify:section:load', pintarTodo);
})();
